var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableauLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2467,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.3 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 40.2h3.3v-9h8.3V28h-8.3v-9h-3.3v9h-8.2v3.2h8.2z",
    fill: "#e8762d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 53.2H16v-8h7.4v-2.5H16v-8.1h-2.8v8.1H5.8v2.5h7.4z",
    fill: "#c72037"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3 24.3h2.8v-8h7.5v-2.4h-7.5V5.8h-2.8v8.1h-7.4v2.4h7.4z",
    fill: "#5b879b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59.5h2.4v-5.7h5.1v-2.1h-5.1V46H29v5.7h-5v2.1h5z",
    fill: "#5c6692"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 24.3h2.6v-8.1h7.5v-2.3h-7.5V5.8h-2.6v8.1H5.8v2.3h7.5z",
    fill: "#eb9129"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 36.3h2.4v-5.6h5.1v-2.2h-5.1v-5.6h-2.4v5.6h-5v2.2h5z",
    fill: "#5c6692"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M44.3 53.2h2.8v-8h7.5v-2.5h-7.5v-8.1h-2.8v8.1h-7.4v2.5h7.4z",
    fill: "#1f457e",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 7.2V5.5h-5V0h-1.8v5.5h-5v1.7h5v5.5h1.8V7.2zM5 35.9h1.8v-5.5h5v-1.7h-5v-5.4H5v5.4H0v1.8l5-.1z",
    fill: "#7199a6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableauLogo);
export default __webpack_public_path__ + "static/media/tableauLogo.be3c51045e321802db1185ec063fa7bd.svg";
export { ForwardRef as ReactComponent };